import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { form_control, UserEdit } from "projects/sepidz-web-framework/src/lib/models";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
@Component({
  selector: "resetpassword",
  templateUrl: "./resetpassword.component.html",
  styleUrls: ["./resetpassword.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetPasswordComponent extends BaseFormComponent<UserEdit> {
  columns: form_control[] = [];
  haserror: boolean = false;
  erroremessage: string;

  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.GNR.ResetPassword.UserName"),
      name: "UserName",
      order: 0,
      listVisible: true,
      formVisible: true,
      required: true,
      textType: "text",
      modelName: "UserName",
      maxLength: 256,
      controlType: FormControlTypes.textbox,
      disabled: true,
      userClass: "select-sm",
    });
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.GNR.ResetPassword.CurrentPassword"),
      name: "OldPassword",
      order: 1,
      listVisible: false,
      formVisible: true,
      required: true,
      textType: "password",
      modelName: "OldPassword",
      controlType: FormControlTypes.textbox,
      maxLength: 128,
      minLength: 3,
      disabled: false,
      userClass: "select-sm",
    });
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.GNR.ResetPassword.NewPassword"),
      name: "NewPassword",
      order: 2,
      listVisible: false,
      formVisible: true,
      required: true,
      textType: "password",
      modelName: "NewPassword",
      controlType: FormControlTypes.textbox,
      maxLength: 128,
      minLength: 3,
      disabled: false,
      userClass: "select-sm",
    });
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.GNR.ResetPassword.ConfirmPassword"),
      name: "ConfirmPassword",
      order: 3,
      listVisible: false,
      formVisible: true,
      required: true,
      textType: "password",
      modelName: "ConfirmPassword",
      controlType: FormControlTypes.textbox,
      maxLength: 128,
      minLength: 3,
      disabled: false,
      userClass: "select-sm",
    });
  }
  async ngOnInit() {
    this.apiName = "Authorization/ChangePassword";
    this.areaName = "General";
    this.label = this.translate("ClientApp.GNR.ResetPassword.ChangePassword");
    this.model = Object.assign({}, this.accountService.getCurrentUser() as UserEdit);
    this.model.UserName = this.accountService.authService.currentUser.UserName;
    this.model.OldPassword = undefined;
    this.orignalColumns = this.columns;
    this.setFormGroup(this.model);
  }

  isValid(): boolean {
    this.erroremessage = undefined;
    this.haserror = false;
    let newPassword: string = this.formGroup.controls["NewPassword"].value;
    if (!newPassword || !(newPassword.length > 0)) {
      this.haserror = true;
      this.erroremessage = this.translate("ClientApp.GNR.ResetPassword.PasswordRequired");
    } else if (newPassword && !newPassword.trim()) {
      this.haserror = true;
      this.erroremessage = this.translate("ClientApp.GNR.ResetPassword.PasswordNotContainOnlyHyphens");
    } else if (newPassword && newPassword != this.formGroup.controls["ConfirmPassword"].value) {
      this.haserror = true;
      this.erroremessage = this.translate("ClientApp.GNR.User.CompareFaild");
    }
    return !this.haserror;
  }
}
